// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__24Ww8","label":"LabeledBox_label__3fBbY"};